namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_method_source_view, {
		
		height: '100%',
		minHeight: 0,
		overflow: 'hidden',
		
		flex: {
			grow: 1,
		},
		
		Body: {
			minHeight: 0,
			flex: {
				grow: 1,
				shrink: 1,
				basis: 0,
			},
		},
		
		Body_content: {
			minHeight: '100%',
		},
		
		Source: {
			width: '100%',
			flex: {
				grow: 1,
				shrink: 0,
				basis: 'auto',
			},
		},
		
	} )
	
}
